export default (date, { MONTHS } = {}) => (date && MONTHS
  ? `${date.substr(6, 2)} ${MONTHS.split(',')[Math.floor(date.substr(4, 2)) - 1].substr(0, 3)}. ${date.substr(0, 4)}`
  : undefined);
